export default {
  'login.title': '관리자 로그인',
  'login.subtitle': '관리자 계정으로 로그인하세요. 계정은 슈퍼 관리자가 할당합니다',
  'login.email': '사용자명 / 이메일',
  'login.emailPlaceholder': '사용자명 또는 이메일을 입력하세요',
  'login.password': '비밀번호',
  'login.passwordPlaceholder': '비밀번호를 입력하세요',
  'login.submit': '로그인',
  'login.loading': '로그인 중...',
  'login.failed': '로그인 실패',
  'login.networkError': '네트워크 오류',
  'login.unknownError': '알 수 없는 오류',
  'login.emptyFields': '사용자명과 비밀번호를 입력하세요',
  'login.showPassword': '비밀번호 표시',
  'login.hidePassword': '비밀번호 숨기기',
  'login.noSelfRegister': '자체 등록은 지원하지 않습니다. 계정이 필요하시면 슈퍼 관리자에게 문의하세요.',
  'login.footerText': '멀티 테넌트 관리 플랫폼',
  'login.brandTitle1': '멀티 테넌트',
  'login.brandTitle2': '관리 콘솔',
  'login.brandSlogan': '테넌트, 사용자, 리소스 및 과금 정책을 통합 관리하여 기업 운영을 더 효율적이고 안전하게.',
  'login.feature1Title': '접근 제어',
  'login.feature1Desc': '엔터프라이즈급 권한 관리 및 감사 로그',
  'login.feature2Title': '데이터 격리',
  'login.feature2Desc': '멀티 테넌트 데이터 격리 및 할당량 관리',
  'login.feature3Title': '모니터링',
  'login.feature3Desc': '실시간 모니터링 대시보드 및 보고서 분석',
  'sidebar.home': '대시보드',
  'sidebar.users': '사용자 및 권한',
  'sidebar.resources': '기능 및 리소스',
  'sidebar.tenants': '테넌트 관리',
  'sidebar.audit': '감사 로그',
  'sidebar.reports': '보고서 분석',
  'sidebar.settings': '시스템 설정',
  'sidebar.admin': '시스템 관리자',
  'header.search': '테넌트, 사용자, 리소스 검색...',
  'header.notifications': '알림',
  'header.viewAll': '모든 알림 보기',
  'header.profile': '프로필',
  'header.settings': '설정',
  'header.logout': '로그아웃',
  'header.notif.newTenant': '새 테넌트 등록',
  'header.notif.newTenantMsg': '테크 이노베이션 회사가 등록되었습니다',
  'header.notif.apiWarning': 'API 사용 경고',
  'header.notif.apiWarningMsg': '테넌트 T002가 할당량 한도에 근접합니다',
  'header.notif.systemUpdate': '시스템 업데이트',
  'header.notif.systemUpdateMsg': '오늘 밤 시스템 유지보수 예정',
  'header.notif.5minAgo': '5분 전',
  'header.notif.1hourAgo': '1시간 전',
  'header.notif.3hoursAgo': '3시간 전',
  'home.title': '관리 개요',
  'home.subtitle': '다시 오신 것을 환영합니다. 멀티 테넌트 관리 플랫폼입니다',
  'home.totalTenants': '총 테넌트 수',
  'home.totalUsers': '총 사용자 수',
  'home.apiCalls': 'API 호출',
  'home.totalRevenue': '총 수입',
  'home.totalSkills': '총 스킬 수',
  'home.chatSessions': '채팅 세션',
  'home.totalMessages': '총 메시지 수',
  'home.systemHealth': '시스템 상태',
  'home.active': '활성',
  'home.activeShort': '활성',
  'home.thisMonth': '이번 달',
  'home.published': '게시됨',
  'home.cumulative': '누적',
  'home.running': '정상 작동',
  'home.vsLastMonth': '전월 대비',
  'home.apiTrend': 'API 사용 추이',
  'home.revenueTrend': '수입 추이',
  'home.quickAccess': '빠른 접근',
  'home.recentActivity': '최근 활동',
  'home.viewAll': '전체 보기',
  'home.tenantDistribution': '테넌트 분포',
  'home.success': '성공',
  'home.failed': '실패',
  'tenants.title': '테넌트 관리',
  'tenants.subtitle': '모든 테넌트의 설정, 할당량 및 과금 정책 관리',
  'tenants.export': '목록 내보내기',
  'tenants.create': '새 테넌트',
  'tenants.total': '총',
  'tenants.unit': '개 테넌트',
  'tenants.clickTip': '행을 클릭하여 상세 보기',
  'tenants.showing': '표시',
  'tenants.to': '-',
  'tenants.of': '중',
  'tenants.records': '건',
  'tenants.createTitle': '새 테넌트',
  'tenants.createSuccess': '테넌트가 성공적으로 생성되었습니다!',
  'tenants.createFailed': '생성 실패',
  'tenants.tenantName': '테넌트 이름',
  'tenants.subdomain': '서브도메인',
  'tenants.contactName': '담당자 이름',
  'tenants.contactEmail': '담당자 이메일',
  'tenants.planType': '요금제 유형',
  'tenants.deployRegion': '배포 지역',
  'tenants.cancel': '취소',
  'tenants.createBtn': '테넌트 생성',
  'tenants.namePlaceholder': '예: 테크 이노베이션 주식회사',
  'tenants.domainPlaceholder': 'techcorp',
  'tenants.contactPlaceholder': '홍길동',
  'tenants.emailPlaceholder': 'admin@company.com',
  'tenants.plan.basic': '기본',
  'tenants.plan.professional': '프로페셔널',
  'tenants.plan.enterprise': '엔터프라이즈',
  'tenants.region.east': '화동',
  'tenants.region.north': '화북',
  'tenants.region.south': '화남',
  'tenants.region.west': '서부',
  'tenantStats.total': '총 테넌트 수',
  'tenantStats.active': '활성 테넌트',
  'tenantStats.totalUsers': '총 사용자 수',
  'tenantStats.monthlyRevenue': '월간 수입',
  'tenantFilters.search': '테넌트 이름, 도메인 또는 담당자 검색...',
  'tenantFilters.allPlans': '모든 요금제',
  'tenantFilters.allStatus': '모든 상태',
  'tenantFilters.active': '활성',
  'tenantFilters.suspended': '정지됨',
  'tenantFilters.trial': '체험 중',
  'tenantTable.info': '테넌트 정보',
  'tenantTable.plan': '요금제',
  'tenantTable.status': '상태',
  'tenantTable.users': '사용자 수',
  'tenantTable.apiCalls': 'API 호출',
  'tenantTable.storage': '저장소',
  'tenantTable.region': '지역',
  'tenantTable.lastActive': '마지막 활동',
  'tenantTable.actions': '작업',
  'tenantTable.viewDetail': '상세 보기',
  'tenantTable.edit': '편집',
  'tenantTable.more': '더보기',
  'tenantTable.noMatch': '일치하는 테넌트가 없습니다',
  'tenantDetail.overview': '개요',
  'tenantDetail.quotaMgmt': '할당량 관리',
  'tenantDetail.dataIsolation': '데이터 격리',
  'tenantDetail.billing': '과금 정보',
  'tenantDetail.createdAt': '생성일',
  'tenantDetail.resourceUsage': '리소스 사용 현황',
  'tenantDetail.apiCallUsage': 'API 호출량',
  'tenantDetail.storageUsage': '저장소',
  'tenantDetail.userCount': '사용자 수',
  'tenantDetail.contactInfo': '연락처 정보',
  'tenantDetail.contact': '담당자',
  'tenantDetail.email': '이메일',
  'tenantDetail.deployRegion': '배포 지역',
  'tenantDetail.lastActive': '마지막 활동',
  'tenantDetail.enabledFeatures': '활성화된 기능',
  'tenantDetail.tags': '테넌트 태그',
  'tenantDetail.quickActions': '빠른 작업',
  'tenantDetail.suspend': '테넌트 정지',
  'tenantDetail.resume': '테넌트 복구',
  'tenantDetail.sendNotice': '알림 전송',
  'tenantDetail.simulateLogin': '로그인 시뮬레이션',
  'tenantDetail.exportData': '데이터 내보내기',
  'tenantDetail.quotaSaved': '할당량이 저장되었습니다',
  'tenantDetail.quotaSettings': '할당량 설정',
  'tenantDetail.quotaDesc': '이 테넌트의 리소스 사용 상한 조정',
  'tenantDetail.maxUsers': '최대 사용자 수',
  'tenantDetail.apiCallsMonth': 'API 호출/월',
  'tenantDetail.storageSpace': '저장소',
  'tenantDetail.currentUsage': '현재 사용량',
  'tenantDetail.saveQuota': '할당량 설정 저장',
  'tenantDetail.isolationSaved': '격리 정책이 저장되었습니다',
  'tenantDetail.isolationPolicy': '데이터 격리 정책',
  'tenantDetail.isolationDesc': '이 테넌트의 데이터 저장 및 격리 방법 선택',
  'tenantDetail.dedicated': '전용 격리',
  'tenantDetail.dedicatedDesc': '전용 데이터베이스 인스턴스를 할당하여 데이터를 완전히 격리, 최고 수준의 보안',
  'tenantDetail.shared': '공유 격리',
  'tenantDetail.sharedDesc': '다른 테넌트와 데이터베이스 인스턴스를 공유, 행 수준 보안으로 데이터 격리',
  'tenantDetail.recommended': '권장',
  'tenantDetail.permissionConfig': '권한 설정',
  'tenantDetail.crossTenantAccess': '교차 테넌트 데이터 접근',
  'tenantDetail.crossTenantDesc': '이 테넌트가 다른 테넌트의 공개 데이터에 접근 허용',
  'tenantDetail.apiRateLimit': 'API 속도 제한',
  'tenantDetail.apiRateLimitDesc': '이 테넌트의 API 요청에 속도 제한 적용',
  'tenantDetail.dataExport': '데이터 내보내기 권한',
  'tenantDetail.dataExportDesc': '이 테넌트가 데이터를 내보낼 수 있도록 허용',
  'tenantDetail.auditAccess': '감사 로그 접근',
  'tenantDetail.auditAccessDesc': '이 테넌트가 자체 감사 로그를 볼 수 있도록 허용',
  'tenantDetail.saveIsolation': '격리 정책 저장',
  'tenantDetail.currentPlan': '현재 요금제 비용',
  'tenantDetail.perMonth': '/ 월',
  'tenantDetail.nextBilling': '다음 결제일',
  'tenantDetail.billDetail': '청구 명세',
  'tenantDetail.baseFee': '기본 요금제 비용',
  'tenantDetail.apiCallFee': 'API 호출 비용',
  'tenantDetail.storageFee': '저장소 비용',
  'tenantDetail.supportFee': '기술 지원 비용',
  'tenantDetail.total': '합계',
  'tenantDetail.historyBills': '청구 이력',
  'tenantDetail.paid': '결제 완료',
  'tenantDetail.download': '다운로드',
  'tenantDetail.feature.aiModels': 'AI 모델',
  'tenantDetail.feature.apiAccess': 'API 접근',
  'tenantDetail.feature.advancedAnalytics': '고급 분석',
  'tenantDetail.feature.basicAnalytics': '기본 분석',
  'tenantDetail.feature.customDomain': '커스텀 도메인',
  'tenantDetail.feature.sso': 'SSO 싱글 사인온',
  'tenantDetail.feature.whiteLabel': '화이트 라벨',
  'users.title': '사용자 및 권한 관리',
  'users.subtitle': '모든 테넌트의 사용자 계정 및 권한 설정 관리',
  'users.addUser': '사용자 추가',
  'users.totalUsers': '총 사용자 수',
  'users.activeUsers': '활성 사용자',
  'users.admins': '관리자',
  'users.developers': '개발자',
  'users.loading': '로딩 중...',
  'userFilters.search': '사용자명, 이메일 또는 테넌트 검색...',
  'userFilters.allRoles': '모든 역할',
  'userFilters.admin': '관리자',
  'userFilters.user': '일반 사용자',
  'userFilters.developer': '개발자',
  'userFilters.allStatus': '모든 상태',
  'userFilters.active': '활성',
  'userFilters.inactive': '비활성',
  'userFilters.moreFilters': '더 많은 필터',
  'userTable.user': '사용자',
  'userTable.tenant': '테넌트',
  'userTable.role': '역할',
  'userTable.status': '상태',
  'userTable.lastLogin': '마지막 로그인',
  'userTable.actions': '작업',
  'userTable.role.admin': '관리자',
  'userTable.role.user': '사용자',
  'userTable.role.developer': '개발자',
  'userTable.status.active': '활성',
  'userTable.status.inactive': '비활성',
  'resources.title': '서비스 설정',
  'resources.subtitle': 'AI 모델, API 키 및 서드파티 서비스 통합 관리',
  'resources.refresh': '새로고침',
  'resources.addConfig': '설정 추가',
  'resources.totalConfigs': '총 설정 수',
  'resources.active': '활성',
  'resources.categories': '카테고리',
  'resources.secrets': '시크릿',
  'resources.addTitle': '새 설정 추가',
  'resources.category': '카테고리',
  'resources.configKey': '설정 키',
  'resources.displayName': '표시 이름',
  'resources.value': '값',
  'resources.description': '설명',
  'resources.secretValue': '시크릿 값',
  'resources.type': '유형:',
  'resources.save': '저장',
  'resources.cancel': '취소',
  'resources.create': '생성',
  'resources.configs': '설정',
  'resources.items': '항목',
  'resources.notConfigured': '미설정',
  'resources.noConfigs': '설정을 찾을 수 없습니다',
  'resources.running': '실행 중',
  'resources.maintenance': '유지보수 중',
  'resources.endpoint': '엔드포인트',
  'resources.usageTenants': '사용 테넌트',
  'resources.usageUnit': '개',
  'resources.usage': '사용량',
  'resources.configure': '설정',
  'resources.stats': '통계',
  'resources.modelType': '유형',
  'resources.version': '버전',
  'resources.callCount': '호출 횟수',
  'resources.cost': '비용',
  'resources.apiKey': 'API 키',
  'resources.edit': '편집',
  'resources.usageStats': '사용 통계',
  'settings.title': '시스템 설정',
  'settings.subtitle': '플랫폼 글로벌 설정, 보안 정책 및 다국어 옵션 관리',
  'settings.tab.general': '기본 설정',
  'settings.tab.services': '서비스 설정',
  'settings.tab.security': '보안 설정',
  'settings.tab.notification': '알림 설정',
  'settings.tab.billing': '과금 방안',
  'settings.tab.locale': '다국어',
  'settings.systemInfo': '시스템 정보',
  'settings.version': '버전',
  'settings.environment': '환경',
  'settings.production': '프로덕션',
  'settings.availability': '가용성',
  'settings.lastBackup': '마지막 백업',
  'settings.todayAt': '오늘 03:00',
  'general.platformInfo': '플랫폼 기본 정보',
  'general.platformName': '플랫폼 이름',
  'general.platformUrl': '플랫폼 주소',
  'general.supportEmail': '지원 이메일',
  'general.timezone': '시간대',
  'general.dateFormat': '날짜 형식',
  'general.maxTenants': '최대 테넌트 수/플랜',
  'general.sessionMaintenance': '세션 및 유지보수',
  'general.sessionTimeout': '세션 타임아웃',
  'general.sessionTimeoutDesc': '사용자 비활성 시 자동 로그아웃',
  'general.minutes': '분',
  'general.maintenanceMode': '유지보수 모드',
  'general.maintenanceDesc': '활성화 시 프론트엔드 사용자에게 유지보수 페이지가 표시됩니다',
  'general.maintenanceWarning': '유지보수 모드가 활성화되었습니다. 모든 프론트엔드 사용자가 플랫폼에 접근할 수 없습니다.',
  'general.reset': '초기화',
  'general.save': '설정 저장',
  'general.saved': '저장됨',
  'security.authPolicy': '인증 정책',
  'security.mfa': '다요소 인증 (MFA) 강제',
  'security.mfaDesc': '모든 관리자 계정에서 MFA를 활성화해야 합니다',
  'security.sso': 'SSO 싱글 사인온',
  'security.ssoProtocol': '현재 프로토콜',
  'security.passwordPolicy': '비밀번호 정책',
  'security.minLength': '최소 비밀번호 길이',
  'security.chars': '자',
  'security.expireDays': '비밀번호 유효기간',
  'security.days': '일',
  'security.maxAttempts': '최대 로그인 실패 횟수',
  'security.times': '회',
  'security.lockoutDuration': '계정 잠금 시간',
  'security.ipWhitelist': 'IP 화이트리스트',
  'security.ipPlaceholder': 'IP 또는 CIDR 입력 (예: 192.168.1.0/24)',
  'security.add': '추가',
  'security.ipWhitelistDesc': '활성화 시 화이트리스트의 IP 주소만 관리자 패널에 접근할 수 있습니다.',
  'security.auditLog': '감사 로그',
  'security.retentionDays': '로그 보관 일수',
  'security.retentionDesc': '보관 기간을 초과한 로그는 자동으로 삭제됩니다',
  'security.reset': '초기화',
  'security.save': '설정 저장',
  'security.saved': '저장됨',
  'notification.channels': '알림 채널',
  'notification.email': '이메일 알림',
  'notification.emailDesc': '이메일로 시스템 경고 및 보고서 전송',
  'notification.sms': 'SMS 알림',
  'notification.smsDesc': 'SMS로 긴급 경고 전송',
  'notification.webhook': 'Webhook 푸시',
  'notification.webhookDesc': '지정된 URL로 이벤트 푸시',
  'notification.webhookUrl': 'Webhook URL',
  'notification.alertEvents': '경고 이벤트',
  'notification.tenantCreate': '새 테넌트 등록',
  'notification.tenantCreateDesc': '새 테넌트가 등록을 완료하면 알림',
  'notification.quotaExceed': '할당량 초과 경고',
  'notification.quotaExceedDesc': '테넌트 API 사용량이 90%를 초과하면 알림',
  'notification.loginFail': '로그인 실패 경고',
  'notification.loginFailDesc': '연속 로그인 실패가 임계값에 도달하면 알림',
  'notification.systemError': '시스템 오류 경고',
  'notification.systemErrorDesc': '심각한 시스템 오류 발생 시 즉시 알림',
  'notification.scheduledReport': '정기 보고서',
  'notification.dailyReport': '일일 보고서',
  'notification.dailyReportDesc': '매일 운영 데이터 요약 전송',
  'notification.sendTime': '전송 시간',
  'notification.recipients': '보고서 수신자',
  'notification.emailPlaceholder': '이메일 주소 입력',
  'notification.addBtn': '추가',
  'notification.reset': '초기화',
  'notification.save': '설정 저장',
  'notification.saved': '저장됨',
  'billing.saved': '요금제가 저장되었습니다',
  'billing.totalPlans': '총 요금제 수',
  'billing.activePlans': '활성 요금제',
  'billing.highestPrice': '최고 가격',
  'billing.editing': '편집 중',
  'billing.cancel': '취소',
  'billing.save': '저장',
  'billing.planName': '요금제 이름',
  'billing.monthlyFee': '월요금 (CNY)',
  'billing.apiCallsMonth': 'API 호출/월',
  'billing.storageSpace': '저장소 (GB)',
  'billing.maxUsers': '최대 사용자 수',
  'billing.supportType': '지원 방식',
  'billing.disabled': '비활성',
  'billing.perMonth': '/ 월',
  'billing.edit': '편집',
  'billing.apiLabel': 'API 호출',
  'billing.storageLabel': '저장소',
  'billing.usersLabel': '사용자 수',
  'billing.supportLabel': '지원',
  'locale.defaultLang': '기본 언어 설정',
  'locale.platformDefault': '플랫폼 기본 언어',
  'locale.platformDefaultDesc': '새 사용자가 처음 방문 시 사용되는 언어',
  'locale.fallbackLang': '대체 언어',
  'locale.fallbackLangDesc': '번역이 없을 때 사용되는 언어',
  'locale.autoDetect': '브라우저 언어 자동 감지',
  'locale.autoDetectDesc': '사용자 브라우저 설정에 따라 자동으로 언어 전환',
  'locale.tenantOverride': '테넌트 언어 사용자 정의 허용',
  'locale.tenantOverrideDesc': '테넌트가 설정에서 플랫폼 기본 언어를 재정의 가능',
  'locale.langManagement': '언어팩 관리',
  'locale.enabled': '활성화',
  'locale.default': '기본',
  'locale.translationCoverage': '번역 커버리지',
  'locale.cannotDisable': '기본 언어는 비활성화할 수 없습니다',
  'locale.coverageNote': '번역 커버리지 설명',
  'locale.coverageDesc': '커버리지가 80% 미만인 언어팩은 일부 UI 요소가 대체 언어로 표시될 수 있습니다. 90% 이상 달성 후 공개를 권장합니다.',
  'locale.save': '설정 저장',
  'locale.saved': '저장됨',
  'serviceConfigs.title': '서비스 설정',
  'serviceConfigs.subtitle': 'AI 모델, 서드파티 API 키 및 외부 서비스 통합 관리',
  'serviceConfigs.refresh': '새로고침',
  'audit.title': '감사 로그',
  'audit.subtitle': '시스템 작업 기록 및 보안 감사',
  'audit.totalLogs': '총 로그 수',
  'audit.totalLogsDesc': '모든 작업 기록',
  'audit.successOps': '성공한 작업',
  'audit.successRate': '성공률',
  'audit.failedOps': '실패한 작업',
  'audit.failedDesc': '관심 필요',
  'audit.todayOps': '오늘 작업',
  'audit.todayDesc': '오늘의 활동',
  'audit.tenant': '테넌트',
  'audit.allTenants': '모든 테넌트',
  'audit.actionType': '작업 유형',
  'audit.allActions': '모든 작업',
  'audit.status': '상태',
  'audit.allStatus': '모든 상태',
  'audit.success': '성공',
  'audit.failed': '실패',
  'audit.timeRange': '시간 범위',
  'audit.allTime': '전체 기간',
  'audit.today': '오늘',
  'audit.last7days': '최근 7일',
  'audit.last30days': '최근 30일',
  'audit.keyword': '키워드 검색',
  'audit.keywordPlaceholder': '사용자, 작업, 리소스 검색...',
  'audit.found': '',
  'audit.records': '건의 기록을 찾았습니다',
  'audit.clearFilter': '필터 초기화',
  'audit.time': '시간',
  'audit.user': '사용자',
  'audit.action': '작업',
  'audit.resource': '리소스',
  'audit.ipAddress': 'IP 주소',
  'audit.actions': '작업',
  'audit.viewDetail': '상세 보기',
  'audit.showing': '표시',
  'audit.prevPage': '이전',
  'audit.nextPage': '다음',
  'audit.detailTitle': '작업 상세',
  'audit.logId': '로그 ID',
  'audit.operationTime': '작업 시간',
  'audit.operationStatus': '작업 상태',
  'audit.tenantInfo': '테넌트 정보',
  'audit.tenantId': '테넌트 ID',
  'audit.tenantName': '테넌트 이름',
  'audit.operationUser': '작업 사용자',
  'audit.userId': '사용자 ID',
  'audit.userName': '사용자 이름',
  'audit.operationInfo': '작업 정보',
  'audit.operationType': '작업 유형',
  'audit.operationResource': '작업 리소스',
  'audit.operationDetail': '작업 상세',
  'audit.networkInfo': '네트워크 정보',
  'audit.userAgent': 'User Agent',
  'reports.title': '보고서 분석',
  'reports.subtitle': '다차원 데이터 분석 및 시각화 보고서',
  'reports.last7days': '최근 7일',
  'reports.last30days': '최근 30일',
  'reports.last90days': '최근 90일',
  'reports.apiTrend': 'API 호출 추이',
  'reports.revenueCompare': '테넌트 수입 비교',
  'reports.resourceUsage': '리소스 사용률',
  'reports.userActivity': '사용자 활동 추이',
  'reports.activeUsers': '활성 사용자',
  'reports.newUsers': '신규 사용자',
  'reports.tenantSummary': '테넌트 데이터 요약',
  'reports.tenantName': '테넌트 이름',
  'reports.apiCalls': 'API 호출',
  'reports.storageUsage': '저장소 사용량',
  'reports.userCount': '사용자 수',
  'reports.revenue': '수입',
  'reports.quotaUsage': '할당량 사용률',
  'langSwitcher.title': '언어 / Language',
};
